import { useEffect } from 'react';
import { isEmpty } from 'underscore';
import useAuthStore from "../../../../store/authStore";
import useGetPriceSummary from "../../../../queries/useGetPriceSummary";
import { PriceSummaryResult } from '../../../../types/checkout';

interface UsePriceSummaryResult {
  priceSummary: PriceSummaryResult;
  emptyPrice: boolean;
  loadingPrice: boolean;
  currency: string;
}

/**
 * Custom hook for managing price summary operations
 * @returns Price summary data and utility functions
 */
export default function usePriceSummary(): UsePriceSummaryResult {
  const user = useAuthStore(state => state.user);
  const userProfile = useAuthStore(state => state.userProfile);
  
  const priceSummaryQuery = useGetPriceSummary();
  const priceSummary = priceSummaryQuery.data || {} as PriceSummaryResult;
  const emptyPrice = isEmpty(priceSummary);
  const loadingPrice = priceSummaryQuery.isLoading;

  useEffect(() => {
    if (isEmpty(user) || userProfile === undefined || isEmpty(userProfile)) {
      // No need to refetch if user is not logged in or user details are not available
      return;
    }

    // Refetch price summary when user or userDetails change
    priceSummaryQuery.refetch();
  }, [user, userProfile, priceSummaryQuery]);

  const currency = priceSummary.CurrencySymbol || '';

  return {
    priceSummary,
    emptyPrice,
    loadingPrice,
    currency,
  };
}
